import {HiristDownload} from '@jobseeker/lotus/assets/icons';
import {Loader} from '@jobseeker/lotus/components';
import {SxProps, Theme, useTheme} from '@mui/material';
import dynamic from 'next/dynamic';
import {Image} from '@jobseeker/lotus/components/Image';

export enum EnquiryType {
  DownloadBrochure = 1,
  Enquire,
}

const PLATFORM = process.env.NEXT_PUBLIC_APP_NAME || '';
const isAppIIMJobs = PLATFORM === 'iimjobs';

const Button = dynamic(
  async () => {
    const Button = isAppIIMJobs
      ? await import('@jobseeker/lotus/elements/ButtonV2')
      : await import('@mui/material/Button');
    return Button;
  },
  {
    loading: () => <></>,
    ssr: false,
  }
);

type EnquiryBtnsProp = {
  text?: string;
  disabled?: boolean;
  handleEnquiryButtonClick?: (type: EnquiryType) => void;
  isDeviceLarge?: boolean;
  sx?: SxProps<Theme> | undefined;
  buttonLoading?: boolean;
};

export const DownloadBrochureBtn = (props: EnquiryBtnsProp) => {
  const {
    disabled = false,
    handleEnquiryButtonClick,
    isDeviceLarge = false,
    sx,
    buttonLoading = false,
  } = props;
  const theme = useTheme();
  return (
    <Button
      variant="contained"
      disabled={disabled}
      size="small"
      data-testid="download_brochure"
      sx={{
        height: 40,
        fontSize: isDeviceLarge ? 16 : 12,
        borderRadius: 5,
        px: 1.375,
        py: 0.625,
        bgcolor: 'transparent',
        color: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`,
        ':hover': {
          bgcolor: 'rgba(73, 150, 110, 0.04)',
          color: theme.palette.primary.main,
        },
        width: '100%',
        fontWeight: 500,
        ...(!isAppIIMJobs && {fontFamily: 'Nunito Sans !important'}),
        ...sx,
        textTransform: 'none !important',
      }}
      className="download-brochure-btn"
      onClick={async () =>
        handleEnquiryButtonClick?.(EnquiryType.DownloadBrochure)
      }
      startIcon={
        !isAppIIMJobs ? (
          <Image
            src={HiristDownload}
            alt="download-brochure"
            height={14}
            width={14}
          />
        ) : (
          ''
        )
      }
    >
      {buttonLoading && !isAppIIMJobs ? <Loader /> : 'Download Brochure'}
    </Button>
  );
};

export const EnquireNowBtn = (props: EnquiryBtnsProp) => {
  const {
    text,
    disabled = false,
    handleEnquiryButtonClick,
    isDeviceLarge = false,
    sx,
    buttonLoading = false,
  } = props;
  const theme = useTheme();
  const isInterestedBtn = text === 'I am interested';
  return (
    <Button
      variant="contained"
      disabled={disabled}
      data-testid="enquire_course"
      size="small"
      className="enquiry-btn"
      sx={{
        fontSize: isDeviceLarge ? 16 : 12,
        fontWeight: 500,
        borderRadius: 5,
        px: 1.375,
        py: 0.625,
        height: 40,
        ...(!isAppIIMJobs && {fontFamily: 'Nunito Sans !important'}),
        width: '100%',
        ...(isInterestedBtn
          ? {
              color: theme.palette.primary.contrastText,
              bgcolor: theme.palette.text.primary,
            }
          : {
              border: disabled
                ? 'none'
                : `1px solid ${theme.palette.primary.main}`,
              color: theme.palette.primary.main,
              bgcolor: 'transparent',
            }),
        ':hover': {
          bgcolor: isInterestedBtn
            ? theme.palette.primary.main
            : 'rgba(73, 150, 110, 0.04)',
          color: isInterestedBtn
            ? theme.palette.primary.contrastText
            : theme.palette.primary.main,
          ...(!isAppIIMJobs && {fontFamily: 'Nunito Sans !important'}),
        },
        ...sx,
        textTransform: 'initial !important',
      }}
      onClick={async () => handleEnquiryButtonClick?.(EnquiryType.Enquire)}
    >
      {buttonLoading && !isAppIIMJobs ? <Loader color="inherit" /> : text}
    </Button>
  );
};
